import { electronOnly } from "src/utils/environment";
import { getAvatars } from "src/modules/avatar/ajax/cloud";
import debug from "src/modules/debug-logger";
import avatarFiles from "src/modules/avatar/avatar-files";
import { replaceAvatars } from "../actions";

export default function synchronizeAvatars() {
  return async (dispatch, getState) => {
    const avatarsArray = await getAvatars();

    const avatars = avatarsArray.reduce((avatarsObj, avatar) => {
      avatarsObj[avatar.objectId] = avatar;
      return avatarsObj;
    }, {});
    dispatch(replaceAvatars(avatars));

    await electronOnly(async () => {
      const savedImages = avatarFiles.getFilenames();

      const promises = avatarsArray.map(async ({ profileImageFile }) => {
        if (profileImageFile && !avatarFiles.exists(profileImageFile.name)) {
          await avatarFiles.download(profileImageFile);
        }
      });
      await Promise.all(promises);

      savedImages.forEach(function deleteIfUnused(filename) {
        const isInUse = avatarsArray.some(({ profileImageFile }) => {
          return profileImageFile ? profileImageFile.name === filename : false;
        });
        if (isInUse === false) {
          debug.synchronizer("About to delete avatar image", filename);
          avatarFiles.delete(filename);
        }
      });
    });
  };
}
